// Generated by purs version 0.14.4
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
var mapUnwrapFlipped = function (dictFunctor) {
    return function (dictNewtype) {
        return function (x) {
            return function (f) {
                return Data_Functor.map(dictFunctor)((function () {
                    var $32 = Data_Newtype.unwrap();
                    return function ($33) {
                        return f($32($33));
                    };
                })())(x);
            };
        };
    };
};
var mapUnwrap = function (dictFunctor) {
    return function (dictNewtype) {
        return function (f) {
            return function (x) {
                return Data_Functor.map(dictFunctor)((function () {
                    var $34 = Data_Newtype.unwrap();
                    return function ($35) {
                        return f($34($35));
                    };
                })())(x);
            };
        };
    };
};
var composeUnwrapRes = function (dictNewtype) {
    return function (g) {
        return function (f) {
            return function (x) {
                return Data_Newtype.unwrap()(g(f(x)));
            };
        };
    };
};
var composeUnwrapFunRes = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (g) {
            return function (f) {
                return function (x) {
                    return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(x))));
                };
            };
        };
    };
};
var composeUnwrapFun = function (dictNewtype) {
    return function (g) {
        return function (f) {
            return function (x) {
                return g(Data_Newtype.unwrap()(f(x)));
            };
        };
    };
};
var composeUnwrapArgFunRes = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (dictNewtype2) {
            return function (g) {
                return function (f) {
                    return function (x) {
                        return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)))));
                    };
                };
            };
        };
    };
};
var composeUnwrapArgFun = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (g) {
            return function (f) {
                return function (x) {
                    return g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x))));
                };
            };
        };
    };
};
var composeUnwrapArg = function (dictNewtype) {
    return function (g) {
        return function (f) {
            return function (x) {
                return g(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var composeFlippedUnwrapRes = function (dictNewtype) {
    return function (f) {
        return function (g) {
            return function (x) {
                return Data_Newtype.unwrap()(g(f(x)));
            };
        };
    };
};
var composeFlippedUnwrapFunRes = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (f) {
            return function (g) {
                return function (x) {
                    return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(x))));
                };
            };
        };
    };
};
var composeFlippedUnwrapFun = function (dictNewtype) {
    return function (f) {
        return function (g) {
            return function (x) {
                return g(Data_Newtype.unwrap()(f(x)));
            };
        };
    };
};
var composeFlippedUnwrapArgFunRes = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (dictNewtype2) {
            return function (f) {
                return function (g) {
                    return function (x) {
                        return Data_Newtype.unwrap()(g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)))));
                    };
                };
            };
        };
    };
};
var composeFlippedUnwrapArgFun = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (f) {
            return function (g) {
                return function (x) {
                    return g(Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x))));
                };
            };
        };
    };
};
var composeFlippedUnwrapArg = function (dictNewtype) {
    return function (f) {
        return function (g) {
            return function (x) {
                return g(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var applyUnwrappedFlipped = function (dictNewtype) {
    return function (x) {
        return function (f) {
            return f(Data_Newtype.unwrap()(x));
        };
    };
};
var applyUnwrapped = function (dictNewtype) {
    return function (f) {
        return function (x) {
            return f(Data_Newtype.unwrap()(x));
        };
    };
};
var applyUnwrapUnwrappedFlipped = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (x) {
            return function (f) {
                return Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var applyUnwrapUnwrapped = function (dictNewtype) {
    return function (dictNewtype1) {
        return function (f) {
            return function (x) {
                return Data_Newtype.unwrap()(f(Data_Newtype.unwrap()(x)));
            };
        };
    };
};
var applyUnwrapFlipped = function (dictNewtype) {
    return function (x) {
        return function (f) {
            return Data_Newtype.unwrap()(f(x));
        };
    };
};
var applyUnwrap = function (dictNewtype) {
    return function (f) {
        return function (x) {
            return Data_Newtype.unwrap()(f(x));
        };
    };
};
export {
    applyUnwrapped,
    applyUnwrap,
    applyUnwrapUnwrapped,
    applyUnwrappedFlipped,
    applyUnwrapFlipped,
    applyUnwrapUnwrappedFlipped,
    composeUnwrapRes,
    composeUnwrapArg,
    composeUnwrapFun,
    composeUnwrapFunRes,
    composeUnwrapArgFun,
    composeUnwrapArgFunRes,
    composeFlippedUnwrapArg,
    composeFlippedUnwrapRes,
    composeFlippedUnwrapFun,
    composeFlippedUnwrapArgFun,
    composeFlippedUnwrapFunRes,
    composeFlippedUnwrapArgFunRes,
    mapUnwrap,
    mapUnwrapFlipped
};
//# sourceMappingURL=index.js.map
